module.exports = __webpack_public_path__ + "89be8e17d505d6226559a9f697fa1a16.svg";